require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./el-real-madrid-el-rival-a-batir.json") })
        }
      }, "path---el-real-madrid-el-rival-a-batir");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---el-real-madrid-el-rival-a-batir!./.cache/json/el-real-madrid-el-rival-a-batir.json
// module id = 448
// module chunks = 231608221292675